import React from 'react'
import './About.css'
import Heading from '../Heading/Heading'

const About = () => {
  return (
    <>
        <div id='about'>
            <Heading thinText={'About'} boldText={'Me'}/>
            <div className="aboutCon">
                <div className="imgBx">
                    <img src="https://res.cloudinary.com/facemetaclone/image/upload/v1664018265/Screenshot_2022-09-24_at_4.47.11_PM_apegud.png" alt="it's me" />
                </div>
                <div className="aboutMe">
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Qui porro, fuga quasi earum est alias asperiores! Consequatur tempora neque quis quas placeat. <br/> <br/> Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel, delectus tempora? In possimus molestiae, provident sed perferendis velit repudiandae iusto, inventore magni eos sunt! Natus adipisci animi in doloribus eius.</p>
                    <div className='btnContainer'>
                        <a herf={'#'}  className="btn active">HIRE ME</a>
                        <a herf={'#'}  className="btn">DOWNLOAD CV</a>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default About